<div
  class="layout-wrapper"
  [ngClass]="{
    'p-input-filled': app.inputStyle === 'filled',
    'p-ripple-disabled': !app.ripple,
    'layout-menu-static': isStatic(),
    'layout-menu-overlay': isOverlay(),
    'layout-menu-horizontal': isHorizontal(),
    'layout-menu-slim': isSlim(),
    'layout-menu-active': menuActive,
    'layout-menu-mobile-active': mobileMenuActive,
    'layout-topbar-mobile-active': mobileTopbarActive,
    'layout-rightmenu-active': rightMenuActive,
    'layout-rtl': app.isRTL,
  }"
  [class]="'layout-menu-' + app.menuTheme + ' layout-topbar-' + app.topbarTheme"
>
  <app-topbar></app-topbar>



  <!--<div class="menu-wrapper" (click)="onMenuClick($event)" style="width:300px">-->


  <div class="layout-main">
    <app-breadcrumb></app-breadcrumb>

    <!--<div class="layout-content" style="padding:10px 10px 10px 80px">-->
    <div class="layout-content" style="padding: 10px 10px 10px 10px">
      <router-outlet></router-outlet>
      <p-confirmDialog
        key="delete_confirmation"
        header="Confirmation !"
        acceptLabel="Yes"
        rejectLabel="No"
      ></p-confirmDialog>
      <p-toast position="top-center" key="alertToast"></p-toast>
    </div>

    <app-footer> </app-footer>
  </div>

  <app-config></app-config>

  <div *ngIf="mobileMenuActive" class="layout-mask modal-in"></div>
</div>
<p-dialog
  [(visible)]="showSessionPopup"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '600px', minWidth: '200px' }"
  [closable]="false"
  [minY]="100"
  [maximizable]="false"
  [baseZIndex]="10000"
>
  <ng-template pTemplate="header">
    <h5 style="text-align: center; width: 100%" class="mb-0">
      Session Timeout
    </h5>
  </ng-template>
  <div class="alignCenter">
    <div class="field col-12 md:col-12">
      <span
        ><img
          src="../../../../assets/images/timer.png"
          width="120px"
          height="125px"
      /></span>
    </div>
    <span class="p-text-secondary block mb-2"
      >Hey are you still there ? <br />
      Your session is going to expire soon due to the inactivity.</span
    >
    <div class="mb-4 bold">
        You will be logged out in {{ secondTimerLeft.split(':')[1] }} seconds
    </div>
  </div>
  <div class="flex justify-content-center gap-2">
    <p-button label="I am here" (click)="continueSession()" />
  </div>
</p-dialog>
<app-error-popup #errorPopup></app-error-popup>
